module.exports = __webpack_public_path__ + "static/media/logo-promo-shell.eba6c1c3.svg";